import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

/**
 * Dashed drop zone for attaching a single file: click to browse or drop a file
 * on it. It only picks the file; the caller validates and uploads it.
 *
 *   <hrra-file-upload
 *     [label]="'label.AttachDocument' | translate"
 *     [hint]="'label.EgRecommendationLetter' | translate"
 *     [fileName]="selectedFileName"
 *     [uploading]="isUploading"
 *     (fileSelected)="onFileSelected($event)">
 *   </hrra-file-upload>
 */
@Component({
  selector: 'hrra-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  imports: [AngularSvgIconModule],
})
export class FileUploadComponent {
  /** call to action shown while no file is chosen */
  @Input() label: string;

  /** secondary line under the label, e.g. what kind of document is expected */
  @Input() hint: string;

  /** name of the chosen file; replaces the label and hint once set */
  @Input() fileName: string | null;

  /** forwarded to the file input's accept attribute */
  @Input() accept: string;

  @Input() uploading = false;
  @Input() invalid = false;
  @Input() disabled = false;

  @Output() fileSelected = new EventEmitter<File>();

  dragging = false;

  onFileInputChange(input: HTMLInputElement) {
    this.select(input.files?.[0]);
    // clear it, so choosing the same file again still fires a change
    input.value = '';
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.dragging = !this.disabled;
  }

  onDragLeave() {
    this.dragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.dragging = false;
    this.select(event.dataTransfer?.files?.[0]);
  }

  private select(file: File | undefined) {
    if (file && !this.disabled) {
      this.fileSelected.emit(file);
    }
  }
}
